import React from "react"
import styled from "styled-components"
import { ChatContentDisplayType } from "../../../../../../../../../components/templates/chat"
import { ChatContent } from "../../../../../../../../../components/templates/chat/components/chat-content"
import { Types } from "../../../../../../../../../rpcs/dist/EpisodeRPC"
import Color from "../../../../../../../../../style/enum/color"
import { EDIT_TYPE, IEditorContent } from "../../../../../../../types"

interface IProps {
  content: IEditorContent
  prevContent: IEditorContent | null
  onClick?: () => void
}

export const EditorChatContent = (props: IProps) => {
  if (isEmptyIntroduction(props.content)) {
    return (
      <StyledEmptyIntroduction onClick={props.onClick}>
        導入文を入力してください
      </StyledEmptyIntroduction>
    )
  }

  const getPrevContent = () => {
    if (
      props.prevContent &&
      props.prevContent._editMetaData.type === EDIT_TYPE.REMOVE
    ) {
      return null
    }
    return props.prevContent
  }

  return (
    <ChatContent
      {...props}
      prevContent={getPrevContent()}
      displayType={ChatContentDisplayType.Editor}
    />
  )
}

export const isEmptyIntroduction = (content: IEditorContent): boolean => {
  if (content.type !== Types.Introduction) {
    return false
  }
  if (content.blocks[0].text === "") {
    return true
  }
  return false
}

const StyledEmptyIntroduction = styled.div`
  text-align: center;
  font-size: 1.2rem;
  font-weight: bold;
  color: ${Color.LIGHT_GRAY};
  cursor: pointer;
  padding: 20px 0;
`
